<template>
  <div id="loyalty_page">
    <div class="container">
      <app-tb-loyalty></app-tb-loyalty>
    </div>
  </div>
</template>
<script>
  import Loyalty from './loyalty'
  export default {
    components: {
      'app-tb-loyalty': Loyalty
    }
  }
</script>



// WEBPACK FOOTER //
// wrapper.vue?99d26b28